import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'

const DEMAND_STAGES_LIST = 'demandStagesList';
const DEMAND_STAGE_SECTIONS_LIST = 'demandStageSectionsList';
const DEMAND_CONTRACTOR_PASSWORD_POPUP = 'offerPasswordPopup';
const STAGE_CURRENT_ROUND = 'stageCurrentRound';

const openContractorPasswordPopup = (successCallback, errorCallback) => {
    reduxStore.dispatch(setResource(DEMAND_CONTRACTOR_PASSWORD_POPUP, {successCallback, errorCallback}));
}

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
}

const getStages = async (demandId, contractorDepartmentId) => {
    try {
        const params = {contractorDepartmentId}

        const res = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGES_LIST(demandId, contractorDepartmentId), {params});
        reduxStore.dispatch(setResource(DEMAND_STAGES_LIST, res));

    } catch (error) {
    }
}

const getStageSections = async (demandId, stageId, supplierId) => {
    try {
        const params = {supplierId}
        const res = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGE_SECTIONS_LIST(demandId, stageId, supplierId), {params});
        const ob = res.reduce((prev, curr) => {
            prev[curr.section] = curr;
            return prev;
        }, {})
        reduxStore.dispatch(setResource(DEMAND_STAGE_SECTIONS_LIST, ob));
    } catch (error) {
    }
}
const getStageTranslations = async (demandId, stageId, supplierId) => {
    try {
        const params = {supplierId}
        return await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGE_TRANSLATIONS(demandId, stageId, supplierId), {params});
    } catch (error) {
    }
}

const getStageSection = async (demandId, stageId, section, supplierId) => {
    try {
        const params = {supplierId}
        const res = await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGE_SECTION(demandId, stageId, section, supplierId), {params});
        const {resources} = reduxStore.getState();
        const list = resources[DEMAND_STAGE_SECTIONS_LIST];
        if(list) {
            const newList = {
                ...list,
                [res.section]: res
            }
            reduxStore.dispatch(setResource(DEMAND_STAGE_SECTIONS_LIST, newList));
        }
    } catch (error) {
    }
}

const getStageCurrentRound = async (demandId, stageId) => {
    try {
        const res = await RestRequestGET(Endpoints.DEMAND_OFFERS_STAGE_CURRENT_ROUND(demandId, stageId));
        reduxStore.dispatch(setResource(STAGE_CURRENT_ROUND, res));
    } catch (error) {
    }
}

const getPasswordStatus = async (demandId, stageId) => {
    return await RestRequestGET(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGE_PASSWORD(demandId, stageId));
}

const savePassword = async (demandId, stageId, password) => {
    return await RestRequestPOST(Endpoints.DEMAND_OFFERS_CONTRACTOR_STAGE_PASSWORD(demandId, stageId), {password});
}
const validate = async (id) => {
    return RestRequestGET(Endpoints.DEMAND_OFFERS_VALIDATE(id));
}

export default {
    getStages,
    getStageSections,
    getStageTranslations,
    clearResources,
    getPasswordStatus,
    openContractorPasswordPopup,
    savePassword,
    getStageCurrentRound,
    getStageSection,
    validate,
    DEMAND_STAGES_LIST,
    DEMAND_STAGE_SECTIONS_LIST,
    DEMAND_CONTRACTOR_PASSWORD_POPUP,
    STAGE_CURRENT_ROUND
}